import React from "react";
import { useState,useEffect } from "react";
import { useNavigate,useLocation ,useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './classes/ChangeApparelOrderStatus.css';
import { DataGrid } from '@mui/x-data-grid';
import { configData } from "../config";
import { Link } from '@mui/material';
import Loading from './Loading';


const columns = [
    {
        field: 'order_number',
        headerName: 'Order Number',  
        headerClassName:'order_number_header',    
        flex:1,
        minWidth: 80,
        // sortable:false,
        renderCell: (params) => (
            <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
                {params.row.order_number}
            </Link>
        ),
    },
    {
        field: 'description',
        headerName: 'Description',
        cellClassName:'description_column',headerClassName:'description_header',   
        flex:1, 
        minWidth: 314,
        // sortable:false,    
    },
    {
        field: 'quantity',
        headerName: 'Quantity',
        cellClassName:'quantity_column',headerClassName:'quantity_header',   
        flex:1, 
        minWidth: 80,
        // sortable:false,    
    },
    {
        field: 'paid_on',
        headerName: 'Paid On',   
        headerClassName:'paid_on_header',
        flex:1,
        minWidth: 100,
        // sortable:false,
    },
    {
        field: 'amount_paid',
        headerName: 'Amount Paid',   
        headerClassName:'amount_paid_header',
        flex:1,
        minWidth: 80,
        // sortable:false,
    },
    {
        field: 'payment_status',
        headerName: 'Payment Status',   
        headerClassName:'payment_status_header',
        flex:1,
        minWidth: 100,
        // sortable:false,
    },
    {
        field: 'shipment_status',
        headerName: 'Shipment Status',   
        headerClassName:'shipment_status_header',
        flex:1,
        minWidth: 100,
        // sortable:false,
    },
     { field: 'yii_orderid', headerName: 'Order ID',  hideable: true,visible: false },
      { field: 'yii_uid', headerName: 'UID',  hideable: true,visible: false },
      { field: 'order_status', headerName: 'Order Status', hideable: true,visible: false },
       { field: 'current_status', headerName: 'Current status', hideable: true,visible: false },
];

const ChangeApparelOrderStatus = () => {

    const customStatus = [
        {label: "Not Planned", value:"need-to-order"},
        {label: "Waiting for Vendor", value:"waiting-for-vendor"},
        {label: "Received", value:"received"},
        {label: "Shipped", value:"shipped"},
        {label: "Completed", value:"completed"}
    ]

    const [isLoading, setIsLoading] = useState(true);
    const [formData, setFormData] = useState({
        custom_status: '',
        description: '',
    })
    const [rowSelectionModel, setRowSelectionModel] = useState({
        type: "include",
        ids: new Set()
    });
    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [quantity, setQuantity] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });
    const [selectedRows, setSelectedRows] = useState([]);
    // const [searchTerm, setSearchTerm] = useState('');
    const [searchValue, setSearchValue] = useState('');
    const[success,setSuccess] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [buttontext, setButtonText] = useState("Submit");
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        yii_orderid: false,
        yii_uid:false,
        order_status:false,
        current_status:false
    });
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const { order_status } = useParams(); 
    const location = useLocation();       

        const fetchData = async () => {
            // Simulate API call to your server
            // In a real application, replace this with your actual fetch logic
            try {
                // setIsLoading(true);
            const response = await fetch(app_url+'smwwcommerceapparel/apparelorderstatuslist', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                page: paginationModel.page,
                pageSize: paginationModel.pageSize,
                sortModel,
                filterModel,
                status:order_status
                }),
            });
            const data = await response.json();
            // console.log(data.data.rows);
            setRows(data.data.rows);
            setRowCount(data.data.totalRowCount); // Server should return totalRowCount
            setQuantity(data.data.totalquantity);
            }  catch (error) {
                console.error('Error fetching data:', error);
            // } finally {
            //     setIsLoading(false); // Set loading to false after fetch completes (success or error)
            }
                
        };
        
    // React.useEffect(() => {
    //     fetchData();
    // }, [paginationModel, sortModel, filterModel]); // Re-fetch data when these change 
    React.useEffect(() => {
        if (searchValue.trim() === '') {
        Promise.all([
           fetchData(),
        ])
        .then(() => {
        setIsLoading(false);
        })}
    }, [paginationModel, sortModel, filterModel, searchValue]);


    useEffect(() => {
        const fetchQueryData = async () => {
            if (searchValue.trim() !== '') {
            //     fetchData();
            //     return;
            // }
                try {
                    const response = await fetch(app_url+'smwwcommerceapparel/apparelorderstatuslist', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                        page: paginationModel.page,
                        pageSize: paginationModel.pageSize,
                        status:order_status,
                        query:searchValue
                        //   sortModel,
                        //   filterModel
                        }),
                    });
                    const data = await response.json();
                    setRows(data.data.rows);
                    setRowCount(data.data.totalRowCount);
                    setQuantity(data.data.totalquantity);
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            }
        };
        const handler = setTimeout(() => {
        fetchQueryData();
        }, 500); 

        return () => {
        clearTimeout(handler);
        };
    }, [searchValue, paginationModel]);

    const getButtonLabel = (pathname) => {
        if (pathname.includes('/need-to-order')) {
            return 'Send to Vendor';
        } else if (pathname.includes('/waiting-for-vendor')) {
            return 'Received';
        } else if (pathname.includes('/received')) {
            return 'Shipped';
        } else if (pathname.includes('/shipped')) {
            return 'Completed';
        } else if (pathname.includes('/completed')) {
            return 'Update';
        }
        return 'Send to Vendor'; // default value
    };

    const buttonValue = getButtonLabel(location.pathname);

    const getPageTitle = (pathname) => {
        if (pathname.includes('/need-to-order')) {
            return 'Not Planned';
        } else if (pathname.includes('/waiting-for-vendor')) {
            return 'Waiting for Vendor';
        } else if (pathname.includes('/received')) {
            return 'Need to Ship';
        } else if (pathname.includes('/shipped')) {
            return 'Complete the order';
        } else if (pathname.includes('/completed')) {
            return 'Completed';
        }
        return 'Not Planned'; // default value
    };

    const pageTitleValue = getPageTitle(location.pathname);

    

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        setFormData({ ...formData, [name]: value });
    };

    // Filter rows based on search term
    // const filteredRows = searchTerm.trim()
    // ? rows.filter((row) => {
    //     const order_number = String(row.order_number || '').toLowerCase();
    //     const description = String(row.description || '').toLowerCase();
    //     const quantity = String(row.quantity || '').toLowerCase();
    //     const paid_on = String(row.paid_on || '').toLowerCase();
    //     const amount_paid = String(row.amount_paid || '').toLowerCase();
    //     const payment_status = String(row.payment_status || '').toLowerCase();
    //     const shipment_status = String(row.shipment_status || '').toLowerCase();
    //     const search = searchTerm.trim().toLowerCase();

    //     return (
    //         order_number.includes(search) ||
    //         description.includes(search) ||
    //         quantity.includes(search) ||
    //         paid_on.includes(search) ||
    //         amount_paid.includes(search) ||
    //         payment_status.includes(search) ||
    //         shipment_status.includes(search)
    //     );
    //     })
    // : rows;

    // Open modal
    const updateStatus = () => {
        if (selectedRows.length > 0) {
            setShowModal(true);
            setErrorMessage('');
        } else {
            setErrorMessage('Please select atleast one item.');
            setSuccess('');
        }
    };

    // Modal Submit
    const updateStatusSubmit = async (e) => {
        e.preventDefault();
        console.log(selectedRows);
        console.log("Submitting form data:", formData);
        setDisabled(true);
        setButtonText("Submitting...");

        const postData = new FormData();
        postData.append('formData', JSON.stringify(formData));
        postData.append('selectedRows', JSON.stringify(selectedRows));
        const response = await fetch(app_url+'smwwcommerceapparel/changeapparelorderstatus', {
            method: 'POST',
            body: postData  
        });
         const data = await response.json();
        if(data.data.msg === "Success") {
            setShowModal(false);
            setButtonText("Submit");
            setDisabled(false);
            setSuccess(data.data.result);
             window.scrollTo(0, 0);
            fetchData();
            setSearchValue('');
        }
    
        
    };

    const handleExport = async (e) => {
        e.preventDefault(); // stop page reload
        try {
            setIsLoading(true);
            const postData = {
                formData:formData,
                status: order_status,  // always send status
            };
            if (selectedRows.length > 0) {
                postData.selectedRowId = selectedRows.map(row => row.id);
            }
            const response = await fetch(app_url+'smwwcommerceapparel/apparelorderstatuslistexport', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(postData),
            });
            const data = await response.json();
            const csvUrl = data.data.csvUrl;
            const urlParts = csvUrl.split('/');
            const fileName = urlParts[urlParts.length - 1];
            const link = document.createElement('a');
            link.href = csvUrl;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        
        }  catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
        }
    };
// useEffect(() => {
//   console.log("Selected rows updated:", selectedRows);
// }, [selectedRows]);
    return (
        <>
         {isLoading ? (
              <Loading />
            ) : (
                <div id="main" className="change-apparel-order-main">
                    <Helmet><title>Change Apparel Order Status</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        {success && (
               
                       <>
                        <br/><div className="set-message-done">
                        <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> <div  dangerouslySetInnerHTML={{ __html: success }}></div>
                        </div></>
                  
                   
                        )}    
                        {errorMessage && (
                            <div className="set-message-error" style={{ padding:"10px 10px 10px 50px",background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`}}>
                                {errorMessage}
                            </div>
                        )} 
                        <a href="/apparel-order-list" style={{fontSize:"20px"}}>←Back</a>
                        <div className="change-apparel-order-container">
                            <div style={{fontWeight:"bold", borderBottom:"1px solid #ddd"}}>
                                <div style={{padding: "10px 15px"}}>Apparel Order Items - {pageTitleValue}</div>
                            </div>
                            <div style={{marginRight: "15px"}}>
                                <a href="#" className="btn btn-blue" onClick={(e) => { e.preventDefault(); updateStatus(); }}>{buttonValue}({quantity})</a>
                            </div>
                            {showModal && (
                                <div id="editModal" className="modal view-event-modal edit-modal-all">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h2>Update status with description</h2>
                                            <span className="close" onClick={() => setShowModal(false)}>×</span>
                                        </div>
                                        <div className="modal-body edit-model">
                                            <label>Status:</label>
                                            <div style={{ marginBottom: "5px" }}>
                                                <select 
                                                    className="" 
                                                    id="custom-status" 
                                                    name="custom_status"
                                                    value={formData.custom_status}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">-Select-</option>
                                                    {customStatus.map((m) => (
                                                    <option key={m.value} value={m.value}>
                                                        {m.label}
                                                    </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <label>Description:</label>
                                            <div style={{ marginBottom: "10px" }}>
                                                <textarea
                                                    type="text"
                                                    name="description"
                                                    value={formData.description}
                                                    onChange={handleChange}
                                                    style={{ width: "100%", marginTop: "5px", height:"50px" }}
                                                />
                                            </div>
                                            <div className="form-item">
                                                <button onClick={updateStatusSubmit} disabled={disabled}>{buttontext}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div style={{clear:"both"}}></div>
                            <div style={{padding: "15px"}}>
                                <div style={{float:"left", marginLeft: "10px"}}><button onClick={handleExport}>Export</button></div>
                                <div style={{float:"right", marginRight: "10px"}} className="change-apparel-order-search">
                                    <label style={{fontWeight:"normal"}}>
                                        Search:
                                        <input 
                                            type="search" 
                                            className="" 
                                            placeholder="" 
                                            aria-controls="example" 
                                            value={searchValue} 
                                            // onChange={(e) => setSearchTerm(e.target.value)} 
                                            onChange={(e) => setSearchValue(e.target.value)}
                                        />
                                    </label>
                                </div>
                                <div style={{clear: "both"}}></div>
                                <div className="" >
                                    <table className="change-apparel-order-table">
                                        <div>
                                            <DataGrid
                                                rows={rows}
                                                columns={columns}
                                                columnVisibilityModel={columnVisibilityModel}
                                                checkboxSelection 
                                                
                                                //disableRowSelectionOnClick
                                                // onCellClick={(params) => {
                                                //     // Get the full row data
                                                //     const fullRowData = params.row;
                                                //     console.log("Clicked row:", fullRowData);
                                                //     // Update the selected row data state
                                                //     if (selectedRows.some((row) => row.id === fullRowData.id)) {
                                                //     setSelectedRows(selectedRows.filter((row) => row.id !== fullRowData.id));
                                                //     } else {
                                                //     setSelectedRows([...selectedRows, fullRowData]);
                                                //     }
                                                //     console.log("Selected rows now:", selectedRows);
                                                // }}
                                                onCellClick={(params) => {
                                                    const fullRowData = params.row;
                                                    // console.log("Clicked row:", fullRowData);

                                                    setSelectedRows(prev => {
                                                        const isSelected = prev.some(row => row.id === fullRowData.id);
                                                        if (isSelected) {
                                                        // Remove from selection
                                                        return prev.filter(row => row.id !== fullRowData.id);
                                                        } else {
                                                        // Add to selection
                                                        return [...prev, fullRowData];
                                                        }
                                                    });
                                                }}
                                                rowSelectionModel={rowSelectionModel}
                                                onRowSelectionModelChange={(newModel) => {
                                                    setRowSelectionModel(newModel);

                                                    const selectedIds = Array.from(newModel.ids);
                                                    const selected = rows.filter(row => selectedIds.includes(row.id));
                                                    setSelectedRows(selected);
                                                    // console.log("Selected rows updated:", selected);
                                                }}
                                                rowCount={rowCount}
                                                paginationMode="server"
                                                sortingMode="server"
                                                filterMode="server"
                                                paginationModel={paginationModel}
                                                onPaginationModelChange={setPaginationModel}
                                                sortModel={sortModel}
                                                onSortModelChange={setSortModel}
                                                filterModel={filterModel}
                                                onFilterModelChange={setFilterModel}
                                                pageSizeOptions={[5, 10, 25,50]}
                                                getRowId={(row) => row.id}
                                                getRowHeight={() => 'auto'}
                                                disableColumnFilter 
                                                // disableColumnResize={true}
                                            />
                                        </div>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="right"></div>
                </div>
            )}
        </>
    );
};

export default ChangeApparelOrderStatus;